import { RouteRecordRaw } from 'vue-router'

export default {
    name: 'foreign-coach',
    path: '/foreign-coach',
    redirect: '/foreign-coach/home',
    component: () => import('@/view/talents/Container.vue'),
    children: [
        {
            name: 'foreignCoachHome',
            path: 'home',
            meta: {
                title: '外籍教练评选',
            },
            component: () => import('@/view/foreign-coach/index.vue'),
        },
        {
            name: 'foreignCoachInfo',
            path: 'info',
            meta: {
                title: '外籍教练评选',
            },
            component: () => import('@/view/foreign-coach/Info.vue'),
        },
    ],
} as RouteRecordRaw
